var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmptyTableState = function SvgEmptyTableState(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 75,
    fill: "#12B4E1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C6DF1",
    d: "M40 69.426V38.75a1 1 0 0 1 1-1h19.104a.5.5 0 0 1 .421.231l4.402 6.915h43.398a1 1 0 0 1 1 1v23.53H40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCD3DC",
    d: "M48.75 55.5h52V62h-52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9DFE5",
    d: "M46.25 58.75h57v6.5h-57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M43.75 62h62v6.5h-62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C6DF1",
    d: "M34.25 65.75h81.295l-6.702 46.729H41.484L34.25 65.75z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyTableState);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/empty-table-state.2d3e302a07f9ee442980a41482b99e51.svg";